<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';
	import Copyright from './Copyright.svelte';
	import ArtificerInnovationsCredit from './ArtificerInnovationsCredit.svelte';
	import ThemeToggle from './ThemeToggle.svelte';
        import { page } from '$app/state';
        import { active } from '$lib/actions/active';

        interface Props {
                config: BrandConfig;
        }

        let { config }: Props = $props();

</script>

<footer style="
	background-color: var(--color--primary, var(--brand-primary));
	color: var(--color--text-inverse, white);
	padding: 2rem;
	margin-top: auto;
	border-top: 2px solid var(--color--secondary, var(--brand-secondary));
	text-align: center;
">
	<div style="
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		max-width: 1200px;
		margin: 0 auto;
	">
		<nav style="display: flex; gap: 1.5rem; flex-wrap: wrap; justify-content: center;">
			<a href={config.links.privacy} use:active>Privacy Policy</a>
			<a href={config.links.terms} use:active>Terms of Service</a>
			<a href={config.links.refunds} use:active>Refunds Policy</a>
			<a href={config.links.contact} use:active>Contact</a>
		</nav>

		<Copyright config={config} />
		<ArtificerInnovationsCredit />
		<ThemeToggle />
	</div>
</footer>

<style>
        nav a {
                color: var(--color--text-inverse, white);
                text-decoration: none;
                font-size: 0.9rem;
                opacity: 0.8;
        }

        :global(nav a.active) {
                color: var(--color--accent, white) !important;
                text-decoration: underline !important;
                text-decoration-thickness: 2px !important;
                text-underline-offset: 4px !important;
        }
</style>
